import { useTranslation } from 'react-i18next';
import { LwButton, Toolbox } from 'redesign';

type CompanyDetailToolboxProps = {
  onBack: () => void;
};

export const CompanyDetailToolbox = ({ onBack }: CompanyDetailToolboxProps) => {
  const { t } = useTranslation('web-common');

  return (
    <Toolbox underline>
      <LwButton color="secondary" onClick={onBack}>
        {t('buttons.back')}
      </LwButton>
    </Toolbox>
  );
};
